module.exports = __webpack_public_path__ + "img/PRNT_04_mono_AE_00001.dd2e17ab.png";